<template>
  <v-container fluid>
    <v-toolbar
      flat
      color="white"
    > 
      <v-row>
        <v-col
          class="py-0 mt-3"
          cols="12"
          lg="6"          
          md="12"
          sm="12"
          xl="4"
        >
          <v-text-field
            v-model="search"
            placeholder="Search file name"
            append-icon="search"
            label="Search file"
            hide-no-data
            hide-selected
            clearable 
          />
        </v-col>
      </v-row>
    </v-toolbar>    

    <v-data-table
      :headers="headers"
      :items="eLetters"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.file_name="{ item }">
        <div>
          <v-icon 
            class="mr-1"
            color="red"
          >
            mdi-file-pdf-box
          </v-icon>
          <a 
            :href="(item.file_url + '?v=' + $moment().unix())" 
            target="_blank" 
          >
            {{ item.file_name }}
          </a>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn
          color="hrissuccess"
          dark
          icon
          medium
          @click="getDocument(item.file_url, item.file_name)"
        >
          <v-icon class="mr-1">
            mdi-download
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        headers: [
          {
            text: 'File',
            align: 'left',
            value: 'file_name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        loading: false,
        eLetters: [],
      }
    },
    created () {
      this.loadData()
    },    
    methods: {    
      loadData () {
        this.$api.companyEmployeeDocuments().show(this.employeeUid)
          .then(res => {
            res.data.company_employees.forEach(companyEmployee => {
              companyEmployee.company_employee_documents.forEach(document => {
                this.eLetters.push(document)
              })
            })

            this.eLetters = _.orderBy(this.eLetters, ['release_date'], ['desc'])
            this.tableLoading = false
          })
      },
      getDocument (fileUrl, fileName) {
        fetch(fileUrl + '?v=' + this.$moment().unix())
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            const objectURL = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = objectURL
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
          })
      }, 
    },
  }
</script>

<style scoped>
  a { 
    color: inherit; 
  }
</style>
